module.exports = __webpack_public_path__ + "static/img/sitx.3e83f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/sitx.png
// module id = VadU
// module chunks = 53